import React from "react";
import { If } from "../If";
import { t } from "../../i18n";
import { navigation } from "../../models/navigation";
import { UserStore } from "../../stores/UserStore";
import { inject, observer } from "mobx-react";

interface IMobileMenuProps {
  hideMenu: () => void;
  userStore?: UserStore;
}

export const MobileMenu = inject("userStore")(observer(class MobileMenu extends React.Component<IMobileMenuProps> {

  private userStore: UserStore;

  constructor(props: any) {
    super(props);

    if (!props.userStore) {
      throw new Error("userStore is not defined");
    }
    this.userStore = props.userStore;

  }

  get contentEnabled() {
    return (
      this.userStore.user &&
      (this.userStore.user.districtContentEnabled ||
        this.userStore.user.schoolContentEnabled)
    )
  }

  render() {
    
    return (
      <>
        <ai-dialog>
          <ai-dialog-body>
            <nav>
              {
                this.contentEnabled ? (
                  <a href="#/dashboard" onClick={() => this.props.hideMenu()}>
                    <i className="material-icons">video_library</i>
                    {t("Browse Videos")}
                  </a>
                ) : (
              <a href="#/" onClick={() => this.props.hideMenu()}>
                <i className="material-icons">home</i>
                {t("Home")}
              </a>
                )
              }
              {navigation
                .filter(item => {
                  if (!item.canUserOpen) {
                    return true;
                  }
                  return item.canUserOpen(this.userStore.user);
                })
              .map((item, index) => (
              <If predicate={item.nav} key={index}>
                <a
                  
                  href={item.href}
                  onClick={() => this.props.hideMenu()}
                >
                  <i className="material-icons">{item.icon}</i>
                  {t(item.title)}
                </a>
              </If>
              ))}

              <a href="#/profile" onClick={() => this.props.hideMenu()}>
                <i className="material-icons">person</i>
                {t("Profile")}
              </a>
              {
                this.userStore.user?.isAppAdmin && (
                  <span className="dummy-link" onClick={() => this.userStore.openAdminModal()}>
                    <i className="material-icons">settings</i>
                    Admin Overrides
                  </span>
                )
              }
            <span className="dummy-link" onClick={() => this.userStore.logout()}>
              <i className="material-icons">logout</i>
              Logout
            </span>
            </nav>
          </ai-dialog-body>

          <ai-dialog-footer>
            <span className="dummy-link" onClick={() => this.props.hideMenu()}>
              <i className="material-icons">close</i>
              Close
            </span>
          </ai-dialog-footer>
        </ai-dialog>
      </>
    );
  }
}))
